import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Loader, Group, Paper,Text, Badge} from '@mantine/core';
import { ArrowBigRightLines, AlertTriangle } from 'tabler-icons-react';
/**
 * Generate wich documents are being in conversion Prozess
 *
 * @return {JSX.Element} JSX element representing selected documents for conversion progress
 */
const DocConvertProgress = () =>{

  const initdocs = useSelector((state: any) => state.user.meetingdocs)
  const docinprogress = useSelector((state: any) => state.user.docsconvertinprogress)
  const [selectedDocs, setSelectedDocs] = useState<any[]>([]);


  useEffect(() => {
    if (docinprogress && docinprogress.length > 0) {
        const selectedDocs = initdocs
        .filter((doc: { resourceId: any; }) => docinprogress.some((item: { resourceId: any; }) => item.resourceId === doc.resourceId))
        .map((doc: { resourceId: any; }) => {
            const matchingItem = docinprogress.find((item: { resourceId: any; }) => item.resourceId === doc.resourceId);
            return { ...doc, error: matchingItem ? matchingItem.error : null };
        });
     setSelectedDocs(selectedDocs);
    } else {    
     setSelectedDocs([]);
    }
    //console.log(docinprogress.length)

}, [initdocs, docinprogress ]);


  const rows = (selectedDocs || []).map((item:any, index:any) => {
    return (
     <>
      {!item.error &&
      <>
      <Text fz="sm"><strong>{item.name}</strong></Text>  
        <Group>
         <Badge color="dark" size="sm" radius="sm">PDF</Badge> 
         <ArrowBigRightLines size={18} color={'#194d23'} /> 
         <Badge color="green" size="sm" radius="sm">PDF/A-1b</Badge> 
         <Loader color="green" variant="dots" size="sm" />
      </Group>
      </>
      }
      {item.error &&
      <>
      <Text fz="sm"><strong>{item.name}</strong></Text>  
        <Group> 
            <AlertTriangle size={24} color={'red'} /> 
            <Text fz="sm" c="red"><strong>{item.error}</strong></Text>
        </Group>  
      </>
      }
      <hr />
     </>
   );
 });


  return (
    <>
       {selectedDocs.length !== 0  &&
        <Paper shadow="sm" p="md">
         <Text fz="sm">Konvertieung von Dokumenten zu <strong>PDF/A-1B</strong></Text>
         <hr />
            {rows}
        </Paper>
       }
    </>
  );
}
export default DocConvertProgress ;